const messages = {
	newComments: {
		id: 'issue-actions.activity-feed.new-comments-floating-button.new-comments.non-final',
		defaultMessage:
			'{unreadCommentsCount} new {unreadCommentsCount, plural, one {comment} other {comments}}',
	},
};

export default messages;
